import { useState } from 'react';

export const useStore = <T = any, P = any>(initForm: T, initState: P) => {
  const [formData, setFormState] = useState(initForm);
  const [stateData, setStateData] = useState(initState);

  function handleFromDataChange(newVal: Partial<typeof formStore>) {
    setFormState((prevState) => ({ ...prevState, ...newVal }));
  }

  function handleStateDataChange(newVal: Partial<typeof stateData>) {
    console.log('handleStateDataChange', newVal);

    setStateData((prevState) => ({ ...prevState, ...newVal }));
  }

  const formStore: any = {
    value: formData,
    set: handleFromDataChange
  };

  const stateStore = {
    value: stateData,
    set: handleStateDataChange
  };

  return { formStore, stateStore, stateData, formData, handleFromDataChange, handleStateDataChange };
};
